var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_c('b-form-input', {
    staticClass: "d-inline-block mr-sm-1 mb-1 mb-sm-0",
    attrs: {
      "placeholder": "Search...",
      "type": "text"
    },
    on: {
      "keyup": _vm.onSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showAttributeModal
    }
  }, [_vm._v(" Add ")])], 1)]), _c('vue-good-table', {
    attrs: {
      "line-numbers": true,
      "rows": _vm.filteredRows,
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (props) {
        return [props.column.field === 'values' ? _c('span', [_c('div', {
          staticClass: "d-flex flex-wrap"
        }, _vm._l(props.row.values, function (value) {
          return _c('b-badge', {
            key: value.id,
            staticClass: "mr-50 mb-50 value-badge",
            attrs: {
              "variant": "light-primary"
            }
          }, [_vm._v(" " + _vm._s(value.value) + " "), _c('feather-icon', {
            staticClass: "ml-50 cursor-pointer",
            attrs: {
              "icon": "Edit2Icon",
              "size": "12"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.showValueModal(props.row, value);
              }
            }
          }), _c('feather-icon', {
            staticClass: "ml-25 cursor-pointer",
            attrs: {
              "icon": "XIcon",
              "size": "12"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.deleteValue(value.id);
              }
            }
          })], 1);
        }), 1)]) : props.column.field === 'format_status' ? _c('span', [_c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-sm",
          attrs: {
            "variant": "outline-warning"
          },
          on: {
            "click": function ($event) {
              return _vm.changeStatus(props.row.id);
            }
          }
        }, [_vm._v(" " + _vm._s(props.row.status ? 'Active' : 'Inactive') + " ")])], 1) : props.column.field === 'created_at' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatFnTableDate(props.row.created_at)) + " ")]) : props.column.field === 'action' ? _c('span', [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function () {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          on: {
            "click": function ($event) {
              return _vm.showAttributeModal(props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "Edit2Icon"
          }
        }), _c('span', [_vm._v("Edit")])], 1), _c('b-dropdown-item', {
          on: {
            "click": function ($event) {
              return _vm.showValueModal(props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "PlusIcon"
          }
        }), _c('span', [_vm._v("Add Value")])], 1), _c('b-dropdown-item', {
          on: {
            "click": function ($event) {
              return _vm.deleteAttribute(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v("Delete")])], 1)], 1)], 1) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-attribute-form",
      "centered": "",
      "title": _vm.attributeForm.id ? 'Edit Attribute' : 'Add Attribute',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.resetAttributeModal
    }
  }, [_c('validation-observer', {
    ref: "attributeValidationRef"
  }, [_c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitAttribute($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Name",
      "label-for": "attribute-name"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "name",
      "vid": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "attribute-name",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Attribute Name"
          },
          model: {
            value: _vm.attributeForm.name,
            callback: function ($$v) {
              _vm.$set(_vm.attributeForm, "name", $$v);
            },
            expression: "attributeForm.name"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "attribute-status"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "status",
      "vid": "status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          attrs: {
            "id": "attribute-status",
            "options": _vm.statusValueOption,
            "reduce": function (option) {
              return option.value;
            },
            "label": "name"
          },
          model: {
            value: _vm.attributeForm.status,
            callback: function ($$v) {
              _vm.$set(_vm.attributeForm, "status", $$v);
            },
            expression: "attributeForm.status"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])], 1)], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-attribute-value-form",
      "centered": "",
      "title": _vm.valueForm.id ? 'Edit Attribute Value' : 'Add Attribute Value',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.resetValueModal
    }
  }, [_c('validation-observer', {
    ref: "valueValidationRef"
  }, [_c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitValue($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "font-weight-bolder"
  }, [_vm._v("Attribute: " + _vm._s(_vm.valueForm.attribute_name || '-'))])]), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Value",
      "label-for": "attribute-value"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "value",
      "vid": "value"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "attribute-value",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Attribute Value"
          },
          model: {
            value: _vm.valueForm.value,
            callback: function ($$v) {
              _vm.$set(_vm.valueForm, "value", $$v);
            },
            expression: "valueForm.value"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }